import { ScriptLinkItem } from "../../localhost/items/ScriptLinkItem";
import { IItem } from "./IItem";

export interface IExternalScriptImageAssociatable extends IItem {
  claioImageId: string;
  externalImageId: string;
  updateImageByExternalScript(info: ScriptLinkItem, departmentId: string): void;
}

export function instanceOfIExternalScriptImageAssociatable(instance: any): instance is IExternalScriptImageAssociatable {
  return instance
//    && (instance.claioImageId !== undefined)  // claioImageIdはundefinedがありえる.
//    && (instance.externalImageId !== undefined)  // externalImageIdはundefinedがありえる.
    && (instance.updateImageByExternalScript !== undefined);
}
